import { Box, Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import SkeletonComponent from 'UiKit/skeleton';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const TableSkeletonParameterByHost = () => {
  return (
    <Box className={styles['table-skeleton__container']} data-testid="table-skeleton__container-all-parameter">
      <Table className={styles['table__skeleton']}>
        <Thead>
          <Tr>
            <Th className={styles['skeleton__head']} minWidth="235px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="60%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="200px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="50%" mb="2px" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="203px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="60%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="177px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="70%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="174px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="70%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="211px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="50%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>

            <Th className={styles['skeleton__head']} minWidth="144px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="50%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>

            <Th className={styles['skeleton__head']} minWidth="168px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="50%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>

            <Th className={styles['skeleton__head']} minWidth="191px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="50%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          <Iteration
            items={[1, 2, 3, 4, 5, 6, 7, 8]}
            render={(num) => {
              return (
                <Tr key={num}>
                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>
                </Tr>
              );
            }}
          />
        </Tbody>
      </Table>
    </Box>
  );
};

export default TableSkeletonParameterByHost;
